"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RightAlignedItem = RightAlignedItem;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _core = require("@linaria/core");
var _react2 = require("@linaria/react");
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _icon = require("@site/pattern-library-utils/icon");
/* eslint-disable max-len */

const Link = /*#__PURE__*/(0, _react2.styled)("a")({
  name: "Link",
  class: "pl-lf0ofes",
  vars: {
    "lf0ofes-7": [({
      icon
    }) => icon ? 'block' : 'none']
  }
});
const text = "pl-t18k3lm8";
const iconStyles = "pl-i1sefsuk";
const iconColor = `${_intents.default.ux.navigateSecondary.foregroundColor}`;
const icons = {
  youtube: /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    className: iconStyles,
    fill: iconColor,
    name: "youtube"
  }),
  twitter: /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    className: iconStyles,
    fill: iconColor,
    name: "twitter"
  }),
  tiktok: /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    className: iconStyles,
    fill: iconColor,
    name: "tiktok"
  }),
  facebook: /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    className: iconStyles,
    fill: iconColor,
    name: "facebook"
  }),
  instagram: /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    className: iconStyles,
    fill: iconColor,
    name: "instagram"
  }),
  linkedin: /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    className: iconStyles,
    fill: iconColor,
    name: "linkedin"
  }),
  help: /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    className: iconStyles,
    fill: iconColor,
    name: "help"
  }),
  tag: /*#__PURE__*/_react.default.createElement(_icon.Icon, {
    className: iconStyles,
    fill: iconColor,
    name: "tag"
  })
};

/**
 * Right aligned nav link.
 *
 * @param {Object} props React props
 * @param {string} props.href Hyperlink
 * @param {string} props.title Text displayed above mobile breakpoint
 * @param {string} props.icon Icon displayed at mobile breakpoint
 * @param {string} props.ariaLabel Icon displayed at mobile breakpoint
 * @param {string} props._name Name for tracking
 * @param {string} props.ariaLabel Aria Label
 * @param {boolean} props.invert Invert to dark styles
 * @param {String} props.partial Theme partial
 * @param {Object} props.rest Additional props spread on anchor element.
 * @returns {React.ReactElement} React HTML element
 * @public
 */
function RightAlignedItem({
  id,
  href,
  title,
  icon = null,
  _name,
  ariaLabel,
  partial,
  invert,
  ...rest
}) {
  return /*#__PURE__*/_react.default.createElement(Link, (0, _extends2.default)({
    id: `id-${id}`,
    "data-partial": partial || (invert ? 'dark1' : ''),
    href: href,
    "aria-label": ariaLabel,
    icon: icon,
    "data-cy": "right-nav-item"
  }, _patternLibraryUtils.tracking.create(_name, true, false), rest), /*#__PURE__*/_react.default.createElement("span", {
    className: text
  }, title), icon && icons[icon.toLowerCase()]);
}
RightAlignedItem.propTypes = {
  id: _propTypes.default.string,
  href: _propTypes.default.string.isRequired,
  title: _propTypes.default.string.isRequired,
  ariaLabel: _propTypes.default.string,
  icon: _propTypes.default.string,
  _name: _propTypes.default.string,
  isProdigy: _propTypes.default.bool,
  invert: _propTypes.default.bool,
  partial: _propTypes.default.string
};